import { useQuery } from "@tanstack/react-query";
import { CalendarDays } from "lucide-react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/** Event / Exhibition dropdown fed by /contacts/events or /leads/events. Hidden when no events exist. */
export function EventFilter({ entity, value, onChange, divisionParam, testid }) {
  const { data } = useQuery({
    queryKey: ["events", entity, divisionParam],
    queryFn: async () => (await api.get(`/${entity}/events`, { params: { division_id: divisionParam } })).data?.events || [],
  });
  const events = data || [];
  if (!events.length && !value) return null;
  return (
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger className="h-9 w-[190px]" data-testid={testid}>
        <CalendarDays className="h-3.5 w-3.5 text-slate-400 mr-1 shrink-0" /><SelectValue placeholder="Event" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All events</SelectItem>
        {value && !events.some((e) => e.name === value) && <SelectItem value={value}>{value}</SelectItem>}
        {events.map((e) => <SelectItem key={e.name} value={e.name}>{e.name} ({e.count})</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
